var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"white"},attrs:{"id":"marquee"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.isamnet},on:{"load":_vm.onLoad}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.isamnet},on:{"load":_vm.onLoad}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.isamnet},on:{"load":_vm.onLoad}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.isamnet},on:{"load":_vm.onLoad}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.isamnet},on:{"load":_vm.onLoad}}),_c('div',{style:({
    width: _vm.adWidth + 'px',
    height: _vm.adHeight + 'px',
    position: 'fixed',
    top: _vm.adTop + 'px',
    overflow: 'hidden',
  }),attrs:{"id":"adRoot"}},[_c('div',{staticClass:"rotatingFerrisWheel",style:({
      top: '12px',
      right: '9px',
      position: 'absolute',
      display: 'block',
      zIndex: '2',
    })},[_c('svg',{staticStyle:{"border":"0px solid black","position":"absolute"},attrs:{"width":"14","height":"14"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":"6","fill":"gray","fill-opacity":"0.3","stroke":"black","stroke-width":"0"}}),_c('line',{attrs:{"x1":"3","y1":"3","x2":"11","y2":"11","stroke":"black","stroke-width":"1.5"}}),_c('line',{attrs:{"x1":"3","y1":"11","x2":"11","y2":"3","stroke":"black","stroke-width":"1.5"}})]),_c('div',{style:({
          width: '11px',
          height: '11px',
          top: '1.5px',
          right: '1.5px',
          position: 'absolute',
          display: 'block',
          zIndex: '2',
      }),on:{"click":function($event){return _vm.closeAd()}}})]),_c('div',{staticClass:"ucmarquee-container"},_vm._l((this.creative.images),function(img,index){return _c('div',{key:index,ref:'item-' + index,refInFor:true,staticClass:"ferris-item",class:{
          'currentAd': index == 0,
          'nextAd': index == 1,
          'preAd': index == 2,
        },style:({
          width: _vm.adWidth + 'px',
          height: _vm.adHeight + 'px',
          position: 'absolute',
          top: '0px',
        }),on:{"transitionend":_vm.onTransitionEnd}},[_c('a',{attrs:{"href":_vm.getHref(img),"target":"_blank"}},[_c('img',{staticClass:"ferris-bg",attrs:{"src":img.urlBack},on:{"load":_vm.onLoad}}),_c('img',{staticClass:"ferris-fg",attrs:{"src":img.urlFront},on:{"load":_vm.onLoad}})])])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }